export default "__VITE_ASSET__50TPUbag__"